import { GridItem } from '@calendly/ui/components/grid';
import { ProTip } from '@calendly/ui/components/pro-tip';
import { BodyText } from '@calendly/ui/components/typography';
import { LeftColumn } from './left_column';
import { CheckboxContainer, CheckboxLeftColumnWrapper, CheckboxRightColumnWrapper, LabelContainer, RightColumnWrapper } from './styles';
const columnLabelContainer = "c1gq7o2d";
const columnGridItem = "c68057r";
const RowFilterLayout = ({
  label,
  tooltip,
  children
}) => <>
    <LeftColumn>
      <LabelContainer>
        <BodyText weight="bold">
          {label}
        </BodyText>
        {tooltip && <ProTip>{tooltip}</ProTip>}
      </LabelContainer>
    </LeftColumn>
    <RightColumnWrapper>
      {children}
    </RightColumnWrapper>
  </>;
const ColumnFilterLayout = ({
  label,
  tooltip,
  children
}) => <GridItem size="12" className={columnGridItem}>
    <LabelContainer className={columnLabelContainer}>
      <BodyText weight="bold">
        {label}
      </BodyText>
      {tooltip && <ProTip>{tooltip}</ProTip>}
    </LabelContainer>
    {children}
  </GridItem>;
export const FilterLayout = ({
  label,
  tooltip,
  children,
  useColumnLayout
}) => {
  const Layout = useColumnLayout ? ColumnFilterLayout : RowFilterLayout;
  return <Layout label={label} tooltip={tooltip}>{children}</Layout>;
};

// Checkbox-specific layouts
const RowCheckboxFilterLayout = ({
  label,
  children
}) => <>
    <CheckboxLeftColumnWrapper>
      <LabelContainer>
        <BodyText weight="bold">
          {label}
        </BodyText>
      </LabelContainer>
    </CheckboxLeftColumnWrapper>
    <CheckboxRightColumnWrapper>
      <CheckboxContainer>
        {children}
      </CheckboxContainer>
    </CheckboxRightColumnWrapper>
  </>;
const ColumnCheckboxFilterLayout = ({
  label,
  children
}) => <GridItem size="12" className={columnGridItem}>
    <LabelContainer className={columnLabelContainer}>
      <BodyText weight="bold">
        {label}
      </BodyText>
    </LabelContainer>
    <CheckboxContainer fieldColumn>
      {children}
    </CheckboxContainer>
  </GridItem>;
export const CheckboxFilterLayout = ({
  label,
  children,
  useColumnLayout
}) => {
  const Layout = useColumnLayout ? ColumnCheckboxFilterLayout : RowCheckboxFilterLayout;
  return <Layout label={label}>{children}</Layout>;
};

require("./filter_layout.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./filter_layout.js");